export const paramAcceptedServices = { limit: 100, page: 1 };

export const paramServiceTypes = {
  limit: 1000,
  page: 1,
  order: "DESC",
  status: 1,
  calc_service: 1,
};
